import { StyledStack } from "./styled";
import { IStackProps } from "./types";

const Stack = (props: IStackProps)=>{
    return (
        <StyledStack {...props}/>
    )
}

export {Stack}